import React, { useState, useCallback, useEffect } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import ModalHeader from "components/global/modal-header";
import LoadingIndicator from "assets/svg/loading-indicator";
import _ from "lodash";
import { useDropzone } from "react-dropzone";
// import { FaPlus, FaMinus } from "react-icons/fa";
import validator from "validator";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import AddPhotoDropZone from "assets/svg/add-photo-dropzone-svg";  
import { KB, MB, maxUploadSize } from "utils/constant";
import { Close } from "assets/svg/sidebar/icons";
import { useTranslation } from "react-i18next";
import Select from "components/select/select";

let ORIENTATION = [
  {
    id: 1,
    label: "Landscape",
    value: "Landscape",
  },
  {
    id: 2,
    label: "Portrait",
    value: "Portrait",
  },
  {
    id: 3,
    label: "Square",
    value: "Square",
  },
];

export default function EditVideoModal({ hide, userData, profile,data={}, ...props }) {
  const { http } = global.services;

  const [link, setLink] = useState(data.link);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [errorMessages, setErrorMessages] = useState({});
  const [adultContent, setAdultContent] = useState(Boolean(data?.is_adult_content));
  const [showReels, setShowReels] = useState(Boolean(data?.is_showreels));
  const [frontPageShowreel, setFrontPageShowreel] = useState(Boolean(data?.is_front_page_showreel));
  const [photo, setPhoto] = useState(null); 
  const [orient, setOrient] = useState(ORIENTATION.find(item => item.value === data?.orientation) ?? ORIENTATION[0]);
  const uploadSizeModal = useDialogHook(UploadSizeModal);
  const {t} = useTranslation()
  React.useEffect(() => {
    if (photo) {
      setPhotoPreview();
    }
  }, [photo]);

  const [preview, setPreview] = useState({
    name: data?.media?.file_name,
    size: data?.media?.file_size,
    path: data?.media?.url,
    orientation: data?.orientation
  });

  const submit = async () => {
    let errors = {};
    setErrorMessages(errors);

    try {
      setSubmitLoading(true); 
      let dataPayload = {
        // user_profile_id: profile.id,
        // type: "video",
        link: null,
        // is_adult_content: adultContent,
      };

        if (link) {
          if (validator.isURL(link)) {
            dataPayload.link = link;
          } else {
            errors = {
              ...errors,
              [`link`]: "Invalid Link",
            };
          }
        } else {
          errors = {
            ...errors,
            [`link`]: "This field is required.",
          };
        }

      if (!_.isEmpty(errors)) {
        return setErrorMessages((prev) => ({ ...prev, ...errors }));
      }

      let payload = new FormData();
      let video_id = data?.id;
      payload.append(`user_profile_id`, profile.id);
      payload.append("type", "video");
      payload.append("link", dataPayload.link); 
      payload.append("is_adult_content", adultContent);
      payload.append("is_showreels", showReels);
      payload.append("is_front_page_showreel", frontPageShowreel);
      payload.append("orientation", orient?.value || "Landscape");
      payload.append("_method", "PUT");

        if (photo && photo[0]) {
            payload.append("thumbnail", photo[0]);
        }

      const response = await http.post(`public/user-galleries/${video_id}`, payload);
      const {data:result} = response;
      console.log(result)
      if (result) {
        // Echo the toggles the user just set, so the caller updates the UI
        // immediately regardless of whether the API response includes them.
        hide({
          data: {
            ...result.data,
            is_showreels: showReels,
            is_front_page_showreel: frontPageShowreel,
            is_adult_content: adultContent,
          },
        });
      }
    } catch (err) {
      if (err.status === 422){
        errors = {
          ...errors,
          ...err.data?.errors,
        };
        console.log(errors)
        return setErrorMessages((prev) => ({
          ...prev,
          ...errors
        }));
      }
        
        
      console.log(err);
      setSubmitLoading(false);
    } finally {
      setSubmitLoading(false);
    }
  };

  // const onAdd = () => {
  //   const copyLinks = _.clone(links);
  //   copyLinks.push("");
  //   setLinks(copyLinks);
  // };

  // const onRemove = (index) => {
  //   let copyLinks = _.clone(links);
  //   let result = update(copyLinks, { $splice: [[index, 1]] });
  //   if (result.length === 0) {
  //     result.push("");
  //   }
  //   setLinks(result);
  // };



  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles[0].size > maxUploadSize) {
      showUploadSizeModalError();
    } else {
      setPhoto(acceptedFiles);
    }
  }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  const removeUploadedPhoto = () => {
    setPhoto(null);
    setPreview({
        name: null,
        size: null,
        path: null,
    });
  }

  useEffect(()=>{
    if(data?.media){
        let size = Number(data?.media?.file_size);
        if (size > MB) {
            size /= MB;
            size = `${Math.round(size * 10) / 10}MB`;
        } else if (size > KB) {
            size /= KB;
            size = `${Math.round(size * 10) / 10}KB`;
        } else {
            size = `${size}B`;
        }
        setPreview((prev)=>{
            return {...prev, size:size}
        })
    }
  },[data])

  const setPhotoPreview = () => {
    console.log(photo[0])
    if (typeof photo === 'string') {
        setPreview({
            name: 'Thumbnail',
            size: 'N/A',
            path: photo
        });
    } else {
        let size = photo[0].size;

        if (size > MB) {
            size /= MB;
            size = `${Math.round(size * 10) / 10}MB`;
        } else if (size > KB) {
            size /= KB;
            size = `${Math.round(size * 10) / 10}KB`;
        } else {
            size = `${size}B`;
        }

        setPreview({
            name: photo[0].name,
            size: size,
            path: URL.createObjectURL(photo[0])
        });
    }
};

  const Footer = () => {
    return (
      <>
        <div className="w-full flex items-center justify-start 1sm:justify-end space-x-2">
          <Button
            buttonName="Cancel"
            buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
            buttonTextClass="text-black text-sm font-semibold"
            onClick={() => hide()}
            disabled={submitLoading}
          />
          <Button
            key="save-btn-category"
            buttonName="Update Link"
            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary"
            buttonTextClass="text-white text-sm font-semibold flex items-center"
            onClick={submit}
            disabled={submitLoading}
            loadingIcon={
              submitLoading ? (
                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
              ) : null
            }
          />
        </div>
      </>
    );
  };


  const toggleAdultContentCheckbox = (e) => {
    setAdultContent(!e.target.checked);
  }

  const toggleShowreelsCheckbox = (e) => {
    setShowReels(e.target.checked);
  }

  const toggleFrontPageShowreelCheckbox = (e) => {
    setFrontPageShowreel(e.target.checked);
  }

  const facebookOrient = async (e) => {
    console.log(e)
    setOrient(e)
  }

  const IsFacebookOrTwitter = ({ value, obj }) => {
          if (
            value.includes("www.facebook.com") ||
            value.includes("twitter.com") ||
            value.includes("x.com") ||
            value.includes("instagram.com") ||
            value.includes("youtube")
          ) {
            return (
              <Select
                // label="Orientation"
                options={ORIENTATION}
                placeholder="Orientation"
                name="orientation"
                value={orient}
                height={58}
                formContainer="w-full flex-1 flex-shrink-0"
                onChange={(e) => facebookOrient(e)}
                // errorMessage={errorMessages?.privacy}
                labelClass="text-sm font-bold text-darkerGray leading-4 marked"
              />
            );
          }
        return <></>;
      };

  return (
    <Modal
      footer={<Footer />}
      width="w-full md:w-15/20 2md:w-11/20 lg:w-9/20 xl:w-6/20"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        {/* header */}
        <ModalHeader title={t('editFile', {file:t('videos')})} hide={hide} />
        {/* content */}
        <div className="px-8.5 pb-6 pt-2">
          {/* profile */}
            <div className="flex flex-column">
              {/* <Input
                inputContainerClass="form-input-container"
                value={link}
                name={`input-link`}
                placeholder="e.g. https://example.com/video"
                outsideLabelClass="text-sm font-bold text-darkerGray"
                noLabelPaddingY="1rem"
                type="text"
                onChange={(e) => handleInputChange(e)}
                errorMessage={errorMessages[`link`] || errorMessages?.video?.link}
                errorMessagePosition="bottom"
              /> */}
          <div className="">
            {/* <div>{thumbnail}</div> */}
            <IsFacebookOrTwitter value={data?.link}/>
            <h1 className="font-bold text-darkerGray mt-3">{t('addAThumbnail')}</h1>
                {/* dropzone */}
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="add-photo-dropzone">
                <AddPhotoDropZone />
              </div>
            </div>
              {
                (photo || preview.path) && <div className="flex mt-4 items-center justify-center">
                  <div className="flex items-center space-x-4 h-[120px] rounded-md shadow-md w-full justify-between border-slate-200">
                    <div className="flex items-center space-x-4 text-ellipsis overflow-hidden">
                      <img
                        src={preview.path}
                        alt="preview-upload"
                        className="relative w-full h-full rounded-md max-h-[120px] max-w-[120px]"
                        style={{objectFit: 'contain' }}
                      />
                      <div className="flex flex-column ">
                        <span className="">{preview.name}</span>
                        <span className="">{preview.size}</span>
                      </div>
                    </div>
                    
                    <div className="cursor-pointer pr-2" onClick={removeUploadedPhoto}>
                      <Close className="w-4 h-4" fill={"#333333"} />
                    </div>
                  </div>
                </div>
              }
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('thisFileDoesNotContainAdult', {file:t('video')})}
                      </p>
                    }
                    name={"termsAndConditions"}
                    checked={!adultContent}
                    onChange={(e) => toggleAdultContentCheckbox(e)}
                    v2={true}
                  />
                </div>
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('makeThisAsYourVideoShowreel')}
                      </p>
                    }
                    name={"termsAndConditions"}
                    checked={showReels}
                    onChange={(e) => toggleShowreelsCheckbox(e)}
                    v2={true}
                  />
                </div>
                <div className="mt-2">
                  <CustomCheckbox
                    label={
                      <p className="checkbox-text">
                        {t('makeThisVideoShowreelInFrontPage')}
                      </p>
                    }
                    name={"makeThisVideoShowreelInFrontPage"}
                    checked={frontPageShowreel}
                    onChange={(e) => toggleFrontPageShowreelCheckbox(e)}
                    v2={true}
                  />
                </div>
              </div>
            </div>
        </div>
        {/* end content */}
      </div>
    </Modal>
  );
}
